import { render, staticRenderFns } from "./CollectionVector.vue?vue&type=template&id=3778a04e&"
import script from "./CollectionVector.vue?vue&type=script&lang=js&"
export * from "./CollectionVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports